// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/memberships/firstparty/v1/current_membership.proto

/* eslint-disable */
import { ApiMembershipStatus, apiMembershipStatusFromJSON, apiMembershipStatusToJSON } from "./membership";

/** Represents a membership. */
export interface ApiCurrentMembership {
  /** Unique identifier for the membership. */
  readonly id: string;
  /** Team ID associated to the membership. */
  readonly teamId?:
    | string
    | null
    | undefined;
  /** Role performed by the membership on the organization. */
  readonly role: string;
  /** User ID associated to the membership. */
  readonly userId: string;
  /** Organization ID associated to the membership. */
  readonly organizationId: string;
  /** The datetime where the membership was created. */
  readonly createdAt: string;
  /** The list of membership's permissions. */
  readonly permissions: { [key: string]: ApiPermissionCategory };
  /**
   * Braze signed JWT token for secure user identification.
   * This token is used to authenticate the user with Braze SDK.
   */
  readonly brazeSignedId: string;
  /** Status of the membership (invited, active, revoked). */
  readonly status: ApiMembershipStatus;
}

export interface ApiCurrentMembershipPermissionsEntry {
  readonly key: string;
  readonly value: ApiPermissionCategory | null;
}

/** Represents a permission category. */
export interface ApiPermissionCategory {
  /** The list of permission rules. */
  readonly rules: readonly ApiRule[];
}

/** Represents a single permission rule. */
export interface ApiRule {
  /** A particular action that can be performed by the membership. */
  readonly action: string;
}

export const ApiCurrentMembership: MessageFns<ApiCurrentMembership> = {
  fromJSON(object: any): ApiCurrentMembership {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      teamId: isSet(object.teamId) ? globalThis.String(object.teamId) : null,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      createdAt: isSet(object.createdAt) ? globalThis.String(object.createdAt) : "",
      permissions: isObject(object.permissions)
        ? Object.entries(object.permissions).reduce<{ [key: string]: ApiPermissionCategory }>((acc, [key, value]) => {
          acc[key] = ApiPermissionCategory.fromJSON(value);
          return acc;
        }, {})
        : {},
      brazeSignedId: isSet(object.brazeSignedId) ? globalThis.String(object.brazeSignedId) : "",
      status: isSet(object.status)
        ? apiMembershipStatusFromJSON(object.status)
        : ApiMembershipStatus.MEMBERSHIP_STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiCurrentMembership): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.teamId !== undefined && message.teamId !== null) {
      obj.teamId = message.teamId;
    }
    if (message.role !== undefined && message.role !== null) {
      obj.role = message.role;
    }
    if (message.userId !== undefined && message.userId !== null) {
      obj.userId = message.userId;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.createdAt = message.createdAt;
    }
    if (message.permissions) {
      const entries = Object.entries(message.permissions);
      if (entries.length > 0) {
        obj.permissions = {};
        entries.forEach(([k, v]) => {
          obj.permissions[k] = ApiPermissionCategory.toJSON(v);
        });
      }
    }
    if (message.brazeSignedId !== undefined && message.brazeSignedId !== null) {
      obj.brazeSignedId = message.brazeSignedId;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiMembershipStatusToJSON(message.status);
    }
    return obj;
  },
};

export const ApiCurrentMembershipPermissionsEntry: MessageFns<ApiCurrentMembershipPermissionsEntry> = {
  fromJSON(object: any): ApiCurrentMembershipPermissionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ApiPermissionCategory.fromJSON(object.value) : null,
    };
  },

  toJSON(message: ApiCurrentMembershipPermissionsEntry): unknown {
    const obj: any = {};
    if (message.key !== undefined && message.key !== null) {
      obj.key = message.key;
    }
    if (message.value !== undefined && message.value !== null) {
      obj.value = ApiPermissionCategory.toJSON(message.value);
    }
    return obj;
  },
};

export const ApiPermissionCategory: MessageFns<ApiPermissionCategory> = {
  fromJSON(object: any): ApiPermissionCategory {
    return { rules: globalThis.Array.isArray(object?.rules) ? object.rules.map((e: any) => ApiRule.fromJSON(e)) : [] };
  },

  toJSON(message: ApiPermissionCategory): unknown {
    const obj: any = {};
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => ApiRule.toJSON(e));
    }
    return obj;
  },
};

export const ApiRule: MessageFns<ApiRule> = {
  fromJSON(object: any): ApiRule {
    return { action: isSet(object.action) ? globalThis.String(object.action) : "" };
  },

  toJSON(message: ApiRule): unknown {
    const obj: any = {};
    if (message.action !== undefined && message.action !== null) {
      obj.action = message.action;
    }
    return obj;
  },
};

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
